if (!customElements.get("collection-list")) {
	class CollectionList extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.selectors = {
				sliderWrapper: ".collection-list__items",
				pagination: ".swiper-pagination",
				nextEl: ".swiper-btn-next",
				prevEl: ".swiper-btn-prev",
			};
			this.classes = {
				grid: "f-grid",
				swiper: "swiper",
				swiperWrapper: "swiper-wrapper",
			};

			this.sectionId = this.dataset.sectionId;
			this.section = this.closest(`.section-${this.sectionId}`);
			this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

			this.enableSlider = this.dataset.enableSlider === "true";
			this.items = parseInt(this.dataset.items);
			this.tabletItems = parseInt(this.dataset.tabletItems);

			this.sliderInstance = false;

			if (!this.enableSlider) return;

			this.initSlider();
		}

		initSlider() {
			const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue("--column-gap");
			const spaceBetween = parseFloat(columnGap.replace("rem", "")) * 10;

			const sliderOptions = {
				spaceBetween: spaceBetween,
				navigation: {
					nextEl: this.section.querySelector(this.selectors.nextEl),
					prevEl: this.section.querySelector(this.selectors.prevEl),
				},
				pagination: false,
				slidesPerView: 1.3,
				centeredSlides: true,
				breakpoints: {
					768: {
						slidesOffsetBefore: 64,
						slidesOffsetAfter: 64,
						slidesPerView: 2.5,
						centeredSlides: false,
					},
					1280: {
						slidesOffsetBefore: 64,
						slidesOffsetAfter: 64,
						slidesPerView: 3.4,
						centeredSlides: false,
					},
				},
				loop: false,
				threshold: 2,
			};

			if (typeof this.sliderInstance !== "object") {
				this.classList.add(this.classes.swiper);
				this.sliderWrapper.classList.remove(this.classes.grid);
				this.sliderWrapper.classList.add(this.classes.swiperWrapper);
				this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
				this.sliderInstance.init();

				const focusableElements = FoxTheme.a11y.getFocusableElements(this);

				focusableElements.forEach((element) => {
					element.addEventListener("focusin", () => {
						const slide = element.closest(".swiper-slide");
						this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
					});
				});
			}

			if (Shopify.designMode && typeof this.sliderInstance === "object") {
				document.addEventListener("shopify:block:select", (e) => {
					if (e.detail.sectionId != this.sectionId) return;
					let { target } = e;
					const index = Number(target.dataset.index);

					this.sliderInstance.slider.slideToLoop(index);
				});
			}
		}
	}
	customElements.define("collection-list", CollectionList);
}
